import { module as BaseModule } from "modujs"
import { load } from "recaptcha-v3"

export default class extends BaseModule {
  init() {
    this.submit = this.el.querySelector("[data-form-submit]")
    this.notice = this.el.querySelector("[data-form-notice]")
    this.listeners()
  }

  listeners() {
    const fields = this.el.querySelectorAll("[data-field]")
    fields.forEach((element) => {
      const elements = element.querySelectorAll("input, textarea, label")
      elements.forEach((el) => {
        el.addEventListener("click", () => {
          element.classList.add("active")
        })
        el.addEventListener("focus", () => {
          element.classList.add("active")
        })

        el.addEventListener("blur", () => {
          if (el.value === "") element.classList.remove("active")
        })
      })
    })
    this.el.addEventListener("submit", this.onSubmit.bind(this))
  }

  async onSubmit(e) {
    try {
      e.preventDefault()
      if (this.isSent || this.isSending) return
      this.notice.classList.add("hidden")

      this.isSending = false
      this.submit.innerHTML = "Sending.."

      const recaptcha = await load("6LcSaxsqAAAAAOpOEPE54aAnBpCqCtCD3FdA-Oc4")
      const token = await recaptcha.execute("form")

      const formData = new FormData(this.el)
      const data = {}
      const formDataArray = Array.from(formData)
      formDataArray.forEach(([key, value]) => {
        data[key] = value
      })
      data["token"] = token

      const request = await fetch("/wp-json/custom/v1/contact", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })

      const response = await request.json()
      const { status } = request
      const { message } = response

      if (status === 200) {
        this.onSuccess()
        this.isSent = true
        this.isSending = false
      } else {
        this.notice.classList.remove("hidden")
        this.notice.innerHTML = message
        this.submit.innerHTML = "Send"
        this.isSending = false
      }
    } catch (error) {
      console.log(error)
    }
  }

  onSuccess() {
    this.submit.innerHTML = "Message sent!"
  }
}
